import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PincodeRoutingModule } from './pincode-routing.module';
import { PincodeComponent } from './pincode.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { CustomFlexLayoutModule } from 'src/app/flex-layout/custom-flex-layout.module';


@NgModule({
  declarations: [
    PincodeComponent
  ],
  imports: [
    CommonModule,
    PincodeRoutingModule,
    MatPaginatorModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    FormsModule,
    MatToolbarModule,
    MatTableModule,
    ReactiveFormsModule,
   CustomFlexLayoutModule
    
  
  ],
  exports:[
    PincodeComponent
  ]
})
export class PincodeModule { }
